import { DELETED_ITEMS, TIMESERIES_TOP_ORDER } from '@const/timeseriesRequest.contants';
import { MetricAggregate } from "./pageResponse.dto";
export type TimeseriesTopOrder = typeof TIMESERIES_TOP_ORDER[keyof typeof TIMESERIES_TOP_ORDER];
export type DeletedItems = typeof DELETED_ITEMS[keyof typeof DELETED_ITEMS];

export type NetflowSource = 'conversations' | 'talkers' | 'interfaces';

// columns of the netflow_agg_<source> tables:
// conversations - src_ip, dst_ip, protocol, service_port (deduplicated across exporters)
// talkers       - host_ip, role (deduplicated across exporters)
// interfaces    - exporter_ip, if_index, direction
export type NetflowDimension = 'exporter_ip' | 'src_ip' | 'dst_ip' | 'protocol' | 'service_port' | 'host_ip' | 'role' | 'if_index' | 'direction';

// Custom timeseries sources — data not backed by object_items/metrics_* tables
export class TimeseriesCustom {
  netflow?: {
    // aggregate table, default conversations
    source?: NetflowSource;
    // one series per distinct combination of these columns, default all columns of the source
    group_by?: NetflowDimension[];
    exporter_ip?: string[];
    src_ip?: string[];
    dst_ip?: string[];
    protocol?: number[];
    service_port?: number[];
    host_ip?: string[];
    // traffic of these IPs in either direction: src_ip OR dst_ip (conversations), host_ip (talkers)
    ip?: string[];
    role?: ('src' | 'dst')[];
    if_index?: number[];
    direction?: ('in' | 'out')[];
  };
}

export class TimeseriesRequestDTO {
  uuid: string[];
  metrics: string[];
  start: number;
  end: number;
  func?: MetricAggregate;
  path?: string;
  custom?: TimeseriesCustom;
}

export class TimeseriesRequestParams {
  top?: number;
  order?: TimeseriesTopOrder;
  fixed?: string[];
  parent?: string;
  interval?: Interval;
  deleted?: DeletedItems;
  skipNull?: boolean;
}

export class PredictionBase {
  item_id: string;
  command: string;
  frequency: string;
  interval: 'year' | 'month';
  max: number;
}

export class PredictionRequestDTO extends PredictionBase {
  metric: string;
  other_metrics: string[];
}

export type Interval = 1 | 5 | 20 | 60 | 360 | 1440;

